import { isFunction } from 'lodash';
import { produce } from '@cld/immer';

export const mergeUniquelyToImmutableArray = (newList, existList, findIndex) => {
  newList.forEach((item) => {
    const indx = findIndex ? findIndex(existList, item) : existList.indexOf(item);

    existList = ~indx
      ? existList.set(indx, item) // found in existing, set inside
      : existList.concat(item); // add new item
  });

  return existList;
};

const throwNonFunctionReducer = (types, action) => {
  throw new Error(`Reducer must provide a function only per type,
                found ${typeof types[action.type]} for type: ${action.type}`);
};

const createReducer = (initialState, types) => (state, action) =>
  types[action.type]
    ? isFunction(types[action.type])
      ? types[action.type](state || initialState, action)
      : throwNonFunctionReducer(types, action)
    : state || initialState;

export const createImmerReducer = (initialState, types) => produce(createReducer(initialState, types));

export default createReducer;
